import { Box, Skeleton } from '@mui/material';

export const TextEditorSkeleton = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
        maxWidth: '648px',
        margin: '0 auto',
        padding: {
          xs: '1rem 1.5rem 30vh',
          sm: '3rem 3rem 30vh',
        },
      }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 2,
          mb: 1,
        }}>
        <Skeleton variant="rectangular" width={120} height={60} sx={{ borderRadius: 1 }} />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, flex: 1, alignItems: 'flex-end' }}>
          <Skeleton variant="text" width="30%" height={18} />
          <Skeleton variant="text" width="40%" height={18} />
          <Skeleton variant="text" width="35%" height={18} />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 3 }}>
        <Skeleton variant="text" width="35%" height={24} />
        <Skeleton variant="text" width="45%" height={24} />
        <Skeleton variant="text" width="35%" height={24} />
        <Skeleton variant="text" width="40%" height={24} />
        <Skeleton variant="text" width="50%" height={24} />
        <Skeleton variant="text" width="75%" height={24} />
        <Skeleton variant="text" width="80%" height={24} />
        <Skeleton variant="text" width="70%" height={24} />
        <Skeleton variant="text" width="50%" height={24} />
      </Box>

      <Box
        sx={{
          display: 'flex',
          height: '100%',
          justifyContent: 'space-between',
          mt: 3,
        }}>
        <Skeleton variant="text" width="15%" height={24} />
        <Skeleton variant="text" width="15%" height={24} />
      </Box>
    </Box>
  );
};
